import { render } from "./garment-ethical.vue?vue&type=template&id=10203ed6&scoped=true"
import script from "./garment-ethical.vue?vue&type=script&lang=js"
export * from "./garment-ethical.vue?vue&type=script&lang=js"

import "./garment-ethical.vue?vue&type=style&index=0&id=10203ed6&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10203ed6"]])

export default __exports__